import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useSeo } from "@/lib/seo";
import { GraduationCap, Coins, Certificate, ArrowRight, Sparkle } from "@phosphor-icons/react";

const META = {
  exam: { label: "Entrance & Board Exams", icon: Certificate, blurb: "Guides to India's major entrance and board exams — pattern, eligibility and how to prepare.", accent: "text-teal-700 bg-teal-50 border-teal-200" },
  scholarship: { label: "Scholarships & Financial Aid", icon: Coins, blurb: "Scholarships, grants and financial aid for Indian students — eligibility, benefits and how to apply.", accent: "text-amber-700 bg-amber-50 border-amber-200" },
  discipline: { label: "Fields of Study", icon: GraduationCap, blurb: "Explore disciplines and courses — specializations, career paths and the exams that lead there.", accent: "text-emerald-700 bg-emerald-50 border-emerald-200" },
};

export default function TopicHub({ type }) {
  const meta = META[type] || META.exam;
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/topics", { params: { type } }).then((r) => setItems(r.data.items || [])).catch(() => setItems([])); }, [type]);
  useSeo(`${meta.label} — IndianEduPulse`, meta.blurb, null);
  const Icon = meta.icon;

  return (
    <div className="mx-auto max-w-6xl px-5 py-14" data-testid={`topic-hub-${type}`}>
      <div className="flex items-start gap-4">
        <span className={`grid h-14 w-14 shrink-0 place-items-center rounded-2xl border ${meta.accent}`}><Icon size={28} weight="duotone" /></span>
        <div>
          <h1 className="font-heading text-4xl font-light tracking-tight sm:text-5xl">{meta.label}</h1>
          <p className="mt-2 max-w-2xl text-muted-foreground">{meta.blurb}</p>
        </div>
      </div>

      {items === null ? (
        <p className="mt-12 text-center text-muted-foreground">Loading guides…</p>
      ) : items.length === 0 ? (
        <p className="mt-12 text-center text-muted-foreground">Guides are being written — check back shortly.</p>
      ) : (
        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="topic-list">
          {items.map((t) => (
            <Link key={t.slug} to={`/topics/${t.slug}`} data-testid={`topic-card-${t.slug}`}
              className="group flex flex-col rounded-2xl border border-border/60 bg-card p-5 transition-all hover:-translate-y-0.5 hover:border-primary/40 hover:shadow-md">
              <h3 className="font-heading text-lg font-medium leading-tight text-foreground">{t.title}</h3>
              {t.summary && <p className="mt-2 line-clamp-3 flex-1 text-sm text-muted-foreground">{t.summary}</p>}
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary">Read guide <ArrowRight size={14} className="transition-transform group-hover:translate-x-0.5" /></span>
            </Link>
          ))}
        </div>
      )}
      <p className="mt-10 inline-flex items-center gap-1.5 rounded-full bg-amber-50 px-3 py-1 text-xs text-amber-700"><Sparkle size={12} weight="fill" /> AI-assisted guides — always verify dates and eligibility on the official website.</p>
    </div>
  );
}
